import { Component, Input } from '@angular/core';
import { FormControlComponent } from '../form-control.component';

@Component({
    selector: 'wncm-form-control-text',
    templateUrl: './form-control-text.component.html',
    styleUrls: ['../form-control.component.scss', './form-control-text.component.scss']
})
export class FormControlTextComponent extends FormControlComponent {
    @Input()
    displayHint: boolean;

    @Input()
    ctype: string;

    @Input()
    iconName: string;

    @Input()
    iconColor = 'black';

    @Input()
    max: string;

    @Input()
    min: string;

    @Input()
    appearance = 'outline';

    @Input()
    readOnly: boolean;

    @Input()
    parameterId: string;

    @Input()
    showClearButton: boolean = false;

    @Input()
    label: string = null;

    constructor() {
        super();
        if (this.readOnly) {
            this.control.disable();
        }
    }
}
